module.exports = __webpack_public_path__ + "img/KMLIcon.12cbf459.jpeg";